import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { apiResponse } from "../../../../utils/apiResponse";
import { apiCall } from "../../../../utils/axiosService";
import { Button, Form, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import Loader from "../../../Loader/Loader";
import { compName, month } from "../../../../utils/constant";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import moment from "moment";
import { API_URL } from "../../../../utils/apiRoutes";
import { Line } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import SixtyDayChild from "../RevPak/SixtyDayChild";
import downArrow from "../../../../Assets/Images/Header/downArrow.svg";
import DoughnutChart from "../../../CommonComponent/DoughnutChart ";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import EventStretegy from "../Event/EventStretegy";

const MonthlyData = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  let datesArray = commonService.getAllDatesInMonth(
    new Date(para?.asOfDate).getFullYear(),
    new Date(para?.asOfDate).getMonth()
  );
  const monthDataArrRef = useRef([]);
  const [monthData, setMonthData] = useState(null);
  const [monthDataLoading, setMonthDataLoading] = useState(false);
  const [showNoteSidebar, setShowNoteSidebar] = useState(false);
  const [widgetModal, setWidgetModal] = useState(false);
  const [chartData, setChartData] = useState(null);
  const widgetDetailRef = useRef();
  const clickedDateForNote = useRef();
  const callApi = useRef(false);
  const isFilterApiCalled = useRef(false);
  const [segmentDrilldownData, setSegmentDrilldownData] = useState(null);
  const [loading, setLoading] = useState(false);
  const rateCodeDataRef = useRef(false);
  const companyDataRef = useRef(false);
  const guestDataRef = useRef(false);
  const totalRef = useRef();
  const clickedTrRef = useRef();
  const selectedMarketSegmentRef = useRef();
  const selectedRateCodeRef = useRef();
  const selectedCompanyRef = useRef();
  const calledMarketSegmentRef = useRef([]);
  const [msLoading, setMsLoading] = useState(false);
  const calledRateCodeRef = useRef([]);
  const [rateCodeLoading, setRateCodeLoading] = useState(false);
  const calledCompanyRef = useRef([]);
  const [companyLoading, setCompanyLoading] = useState(false);
  const [msChartData, setMsChartData] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("");
  const monthStartDateRef = useRef();
  const monthEndDateRef = useRef();
  const bookingPaceChartDateRef = useRef();
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const closeNoteSideBar = () => {
    setShowNoteSidebar(false);
  };

  var curr = new Date(para?.asOfDate);
  var first = curr.getDate() - curr.getDay();
  var last = first + 6;

  var firstday = new Date(curr.setDate(first));
  var lastday = new Date(curr.setDate(last));

  const getDataForMonth = async () => {
    let date = moment(para?.asOfDate);
    setMonthDataLoading(true);
    let dataForMonthResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.EMAIL_WIDGET.DAILY_DATA_WIDGET_TWO,
        body: {
          propertyCode: para?.propertyCode,
          AsOfDate: para?.asOfDate,
          year: new Date(para?.asOfDate).getFullYear(),
          startDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.startOf("month").format("YYYY-MM-DD"),
        },
      },
      false
    );

    let response = apiResponse(false, dataForMonthResponse);

    if (response?.isValidate) {
      let asDate1 = new Date(
        monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
      );
      let asDate2 = new Date(
        monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
      );
      let prevAsDate = new Date(asDate1.setMonth(asDate1.getMonth() - 1));
      let nextAsDate = new Date(asDate2.setMonth(asDate2.getMonth() + 1));
      monthDataArrRef.current = [
        moment(prevAsDate).format("MMMM"),
        moment(
          monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
        ).format("MMMM"),
        moment(nextAsDate).format("MMMM"),
      ];
      setMonthData(response?.data?.data);
      setMonthDataLoading(false);
    }

    if (!response?.isValidate) {
      let asDate1 = new Date(
        monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
      );
      let asDate2 = new Date(
        monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
      );
      let prevAsDate = new Date(asDate1.setMonth(asDate1.getMonth() - 1));
      let nextAsDate = new Date(asDate2.setMonth(asDate2.getMonth() + 1));
      monthDataArrRef.current = [
        moment(prevAsDate).format("MMMM"),
        moment(
          monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
        ).format("MMMM"),
        moment(nextAsDate).format("MMMM"),
      ];
      setMonthData(null);
      setMonthDataLoading(false);
    }
  };

  let prevYear = {
    label: "Prev Year",
    backgroundColor: "#97C2E0",
    data: [],
    stack: "stack1",
  };

  let currentYear = {
    label: "Current Year",
    backgroundColor: "#7ACFA2",
    data: [],
    stack: "stack2",
  };

  const getBookingPaceDetail = async () => {
    let bookingPaceResponse = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.SnapShot + API_URL.BOOKING_PACE.CHART,
        body: {
          AsOfDate: bookingPaceChartDateRef.current
            ? bookingPaceChartDateRef.current
            : para?.asOfDate,
          propertyCode: para?.propertyCode,
        },
      },
      false
    );

    let response = apiResponse(false, bookingPaceResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data;

      datesArray?.map((item) => {
        let findData = dataFromApi?.filter(
          (x) => {
            if (
              commonService.convertDateInTimezone(x?.Dates).getDate() === item
            ) {
              return x;
            }
          }
          // new Date(x?.Dates).getDate() === item
        );
        prevYear.data = [
          ...prevYear.data,
          findData?.[0]?.TotalRevenuePreviousYear
            ? findData?.[0]?.TotalRevenuePreviousYear
            : 0,
        ];
        currentYear.data = [
          ...currentYear.data,
          findData?.[0]?.TotalRevenueCurrentYear
            ? findData?.[0]?.TotalRevenueCurrentYear
            : 0,
        ];
      });

      setChartData([prevYear, currentYear]);
    }

    if (!response?.isValidate) {
      prevYear.data = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0,
      ];
      currentYear.data = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0,
      ];
      setChartData([prevYear, currentYear]);
    }
  };
  let chartDetail = {};
  if (chartData) {
    chartDetail = {
      labels: datesArray,
      datasets: [
        {
          type: "line",
          label: `${new Date().getFullYear() - 1}`,
          backgroundColor: chartData?.[0]?.backgroundColor,
          data: chartData?.[0]?.data,
          stack: chartData?.[0]?.stack || "default",
          fill: {
            target: "origin",
            above: "rgba(151, 194, 224, 0.4)",
          },
        },
        {
          type: "line",
          label: `${new Date().getFullYear()}`,
          backgroundColor: chartData?.[1]?.backgroundColor,
          data: chartData?.[1]?.data,
          // fill: true,
          fill: {
            target: "origin",
            above: "rgba(122, 207, 162, 0.4)",
          },
          stack: chartData?.[1]?.stack || "default",
        },
      ],
    };
  }

  let chartOptions = {
    indexAxis: "x",
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: "",
        },
        ticks: {
          align: "start",
          autoSkip: false,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "",
        },
        grid: {
          display: true,
        },
        offset: true,
        ticks: {
          callback: function (value) {
            return `${
              propertyDetailFromRTK?.currency_term
                ? propertyDetailFromRTK?.currency_term
                : "$"
            }${value}`;
          },
        },
      },
    },

    plugins: {
      legend: {
        display: true,
        align: "end",
        position: "top",
        maxWidth: 20,
        maxHeight: 100,
        labels: {
          boxWidth: 10,
          boxHeight: 10,
        },
      },
      tooltip: {
        enabled: true,
        mode: "index",
        callbacks: {
          title: function (context) {
            return context[0].label;
          },
          label: function (context) {
            let label = context.dataset.label;
            let value = context.formattedValue;
            return `${label}: ${value}`;
          },
        },
      },
    },
    responsive: true,
    barThickness: 12,
    categorySpacing: 0.3,
    barPercentage: 0.8,
    categoryPercentage: 0.9,
  };

  Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    Filler
  );

  const showOnApiCall = (idArray) => {
    for (let i = 0; i < idArray?.length; i++) {
      const classList = document.getElementsByClassName(idArray[i]);
      for (let i = 0; i < classList?.length; i++) {
        if (classList[i].classList.contains("nestedTableRowNone")) {
          classList[i].classList.remove("nestedTableRowNone");
          classList[i].classList.add("singleDateSummmaryTr");
        }
      }
    }
  };

  const handleShowHideRow = (className, itemDetail) => {
    if (document.getElementById(className) !== null) {
      if (document.getElementById(className).classList.contains("active")) {
        document.getElementById(className).classList.remove("active");
      } else {
        document.getElementById(className).classList.add("active");
      }
    }

    const removeClass = (classNameDetail) => {
      const classList = document.getElementsByClassName(classNameDetail);
      for (let i = 0; i < classList?.length; i++) {
        if (classList[i].classList.contains("nestedTableRowNone")) {
          classList[i].classList.remove("nestedTableRowNone");
          classList[i].classList.add("singleDateSummmaryTr");
        } else {
          classList[i].classList.add("nestedTableRowNone");
          classList[i].classList.remove("singleDateSummmaryTr");
        }
      }
    };

    removeClass(className);

    const addChildClass = (childClassName) => {
      const classList = document.getElementsByClassName(childClassName);
      for (let i = 0; i < classList?.length; i++) {
        if (!classList[i].classList.contains("nestedTableRowNone")) {
          classList[i].classList.add("nestedTableRowNone");
          classList[i].classList.remove("singleDateSummmaryTr");
        }
      }
    };

    const removeAllClass = (childItems) => {
      for (let i = 0; i < childItems?.length; i++) {
        addChildClass(childItems[i]?.guid);

        if (
          Array.isArray(childItems[i]?.items) &&
          childItems[i]?.items?.length > 0
        ) {
          removeAllClass(childItems[i]?.items);
        }
      }
    };

    if (Array.isArray(itemDetail?.items) && itemDetail?.items?.length > 0) {
      removeAllClass(itemDetail?.items);
    }
  };

  const checkActiveRow = (e, guid, itemDetail) => {
    if (e.currentTarget.classList.contains("active")) {
      e.currentTarget.classList.remove("active");
      e.currentTarget.classList.remove("singleDateSummmaryTr");
    } else {
      e.currentTarget.classList.add("active");
      e.currentTarget.classList.add("singleDateSummmaryTr");
    }
  };

  const getMarketSegmentData = async () => {
    let date = moment(para?.asOfDate);
    setLoading(true);

    let marketSegmentResponse = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.SnapShot + API_URL.EMAIL_WIDGET.MONTHLY_MS,
        body: {
          propertyCode: para?.propertyCode,
          AsOfDate: para?.asOfDate,
          startDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.startOf("month").format("YYYY-MM-DD"),
          endDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.endOf("month").format("YYYY-MM-DD"),
        },
      },
      false
    );

    let response = apiResponse(false, marketSegmentResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data;
      let total = {
        leftRoom: 0,
        leftAdr: 0,
        leftRev: 0,
        leftRevContri: 100,
        rightRoom: 0,
        rightAdr: 0,
        rightRev: 0,
        rightRevContri: 100,
      };
      let doughnutData = {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [],
            hoverBackgroundColor: [],
          },
        ],
      };

      let groupingData = dataFromApi?.map((item) => {
        // let color = Math.floor(Math.random() * 16777215).toString(16);
        let color = commonService.CreateColor(`${item.marketsegment}`).BGColor;
        let marketSegmentName = item.marketsegment;
        let marketSegmentPr = item?.left_RMS ? item?.left_RMS : 0;
        doughnutData.labels.push(marketSegmentName);
        doughnutData.datasets[0].data.push(marketSegmentPr);
        doughnutData.datasets[0].backgroundColor.push(`${color}`);
        doughnutData.datasets[0].hoverBackgroundColor.push(`${color}`);

        item.items = [];
        item.guid = commonService.GenerateGUID();
        item.name = item?.marketsegment;
        item.varientRms =
          (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
          (item?.right_RMS ? parseInt(item?.right_RMS) : 0);
        item.varientAdr =
          (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
          (item?.right_ADR ? parseInt(item?.right_ADR) : 0);
        item.varientRev =
          (item?.left_REV ? parseInt(item?.left_REV) : 0) -
          (item?.right_REV ? parseInt(item?.right_REV) : 0);

        if (item?.left_RMS) {
          total.leftRoom = total.leftRoom + parseInt(item?.left_RMS);
        }
        if (item?.left_ADR) {
          total.leftAdr = total.leftAdr + parseInt(item?.left_ADR);
        }
        if (item?.left_REV) {
          total.leftRev = total.leftRev + parseInt(item?.left_REV);
        }

        if (item?.right_RMS) {
          total.rightRoom = total.rightRoom + parseInt(item?.right_RMS);
        }
        if (item?.right_ADR) {
          total.rightAdr = total.rightAdr + parseInt(item?.right_ADR);
        }
        if (item?.right_REV) {
          total.rightRev = total.rightRev + parseInt(item?.right_REV);
        }

        return item;
      });

      setMsChartData(doughnutData);
      setSegmentDrilldownData(groupingData);
      totalRef.current = total;
      setLoading(false);
    }

    if (!response?.isValidate) {
      setSegmentDrilldownData([]);
      setLoading(false);
    }
  };

  const getRateCodeData = async () => {
    let date = moment(para?.asOfDate);
    setMsLoading(true);
    let rateCodeResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot + API_URL.EMAIL_WIDGET.MONTHLY_RATECODE,
        body: {
          propertyCode: para?.propertyCode,
          AsOfDate: para?.asOfDate,
          selectedMarketSegment: selectedMarketSegmentRef.current,
          startDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.startOf("month").format("YYYY-MM-DD"),
          endDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.endOf("month").format("YYYY-MM-DD"),
        },
      },
      false
    );

    let response = apiResponse(false, rateCodeResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data;

      let groupingJson = [...segmentDrilldownData];

      dataFromApi?.forEach((item) => {
        let findMarketsegment = groupingJson?.findIndex(
          (x) => x?.name === item?.MarketSegment
        );

        if (findMarketsegment >= 0) {
          item.name = item?.RateCode;
          item.items = [];
          item.varientRms =
            (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
            (item?.right_RMS ? parseInt(item?.right_RMS) : 0);
          item.varientAdr =
            (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
            (item?.right_ADR ? parseInt(item?.right_ADR) : 0);
          item.varientRev =
            (item?.left_REV ? parseInt(item?.left_REV) : 0) -
            (item?.right_REV ? parseInt(item?.right_REV) : 0);
          item.guid = commonService.GenerateGUID();
          groupingJson[findMarketsegment].items = [
            ...groupingJson?.[findMarketsegment]?.items,
            item,
          ];
        }
      });
      calledMarketSegmentRef.current = [
        ...calledMarketSegmentRef.current,
        selectedMarketSegmentRef.current,
      ];
      setSegmentDrilldownData(groupingJson);
      setMsLoading(false);
    }

    if (!response?.isValidate) {
      setMsLoading(false);
    }
  };

  const getCompanyData = async () => {
    let date = moment(para?.asOfDate);
    setRateCodeLoading(true);
    let companyDataResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot + API_URL.EMAIL_WIDGET.MONTHLY_COMPANY,
        body: {
          propertyCode: para?.propertyCode,
          AsOfDate: para?.asOfDate,
          selectedMarketSegment: selectedMarketSegmentRef.current,
          selectedRateCode: selectedRateCodeRef.current,
          startDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.startOf("month").format("YYYY-MM-DD"),
          endDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.endOf("month").format("YYYY-MM-DD"),
        },
      },
      false
    );

    let response = apiResponse(false, companyDataResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data;

      let groupingJson = [...segmentDrilldownData];

      dataFromApi?.forEach((item) => {
        let findMarketsegment = groupingJson?.findIndex(
          (x) => x?.name === item?.MarketSegment
        );
        let findRatecode = groupingJson[findMarketsegment].items?.findIndex(
          (x) => x?.name === item?.RateCode
        );

        if (findRatecode >= 0) {
          item.name = item?.Company;
          item.items = [];
          item.varientRms =
            (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
            (item?.right_RMS ? parseInt(item?.right_RMS) : 0);
          item.varientAdr =
            (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
            (item?.right_ADR ? parseInt(item?.right_ADR) : 0);
          item.varientRev =
            (item?.left_REV ? parseInt(item?.left_REV) : 0) -
            (item?.right_REV ? parseInt(item?.right_REV) : 0);
          item.guid = commonService.GenerateGUID();
          groupingJson[findMarketsegment].items[findRatecode].items = [
            ...groupingJson[findMarketsegment].items[findRatecode].items,
            item,
          ];
        }
      });
      calledRateCodeRef.current = [
        ...calledRateCodeRef.current,
        {
          ms: selectedMarketSegmentRef.current,
          rc: selectedRateCodeRef.current,
        },
      ];
      setSegmentDrilldownData(groupingJson);
      setRateCodeLoading(false);
    }

    if (!response?.isValidate) {
      setRateCodeLoading(false);
    }
  };

  const getGuestData = async () => {
    let date = moment(para?.asOfDate);
    setCompanyLoading(true);
    let guestDataResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.EMAIL_WIDGET.MONTHLY_GUESTNAME,
        body: {
          propertyCode: para?.propertyCode,
          AsOfDate: para?.asOfDate,
          selectedMarketSegment: selectedMarketSegmentRef.current,
          selectedRateCode: selectedRateCodeRef.current,
          selectedCompany: selectedCompanyRef.current,
          startDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.startOf("month").format("YYYY-MM-DD"),
          endDate: monthStartDateRef.current
            ? monthStartDateRef.current
            : date.endOf("month").format("YYYY-MM-DD"),
        },
      },
      false
    );

    let response = apiResponse(false, guestDataResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data;

      let groupingJson = [...segmentDrilldownData];

      dataFromApi?.forEach((item) => {
        let findMarketsegment = groupingJson?.findIndex(
          (x) => x?.name === item?.MarketSegment
        );
        let findRatecode = groupingJson[findMarketsegment].items?.findIndex(
          (x) => x?.name === item?.RateCode
        );

        let findCompany = groupingJson[findMarketsegment].items[
          findRatecode
        ].items?.findIndex((x) => x?.name === item?.Company);

        if (findCompany >= 0) {
          item.name = item?.GuestName;
          item.items = [];
          item.varientRms =
            (item?.left_RMS ? parseInt(item?.left_RMS) : 0) -
            (item?.right_RMS ? parseInt(item?.right_RMS) : 0);
          item.varientAdr =
            (item?.left_ADR ? parseInt(item?.left_ADR) : 0) -
            (item?.right_ADR ? parseInt(item?.right_ADR) : 0);
          item.varientRev =
            (item?.left_REV ? parseInt(item?.left_REV) : 0) -
            (item?.right_REV ? parseInt(item?.right_REV) : 0);
          item.guid = commonService.GenerateGUID();
          groupingJson[findMarketsegment].items[findRatecode].items[
            findCompany
          ].items = [
            ...groupingJson[findMarketsegment].items[findRatecode].items[
              findCompany
            ].items,
            item,
          ];
        }
      });
      calledCompanyRef.current = [
        ...calledCompanyRef.current,
        {
          ms: selectedMarketSegmentRef.current,
          rc: selectedRateCodeRef.current,
          company: selectedCompanyRef.current,
        },
      ];
      setSegmentDrilldownData(groupingJson);
      setCompanyLoading(false);
    }

    if (!response?.isValidate) {
      setCompanyLoading(false);
    }
  };

  useEffect(() => {
    if (api === 0) {
      let asDate11 = new Date(para?.asOfDate);
      let asDate22 = new Date(para?.asOfDate);
      let prevAsDate = new Date(asDate11.setMonth(asDate11.getMonth() - 1));
      let nextAsDate = new Date(asDate22.setMonth(asDate22.getMonth() + 1));
      monthDataArrRef.current = [
        moment(prevAsDate).format("MMMM"),
        moment(para?.asOfDate).format("MMMM"),
        moment(nextAsDate).format("MMMM"),
      ];
    } else {
      if (para?.asOfDate) {
        getDataForMonth();
        getBookingPaceDetail();
      }
    }
  }, [para?.asOfDate, selectedMonth]);

  useEffect(() => {
    if (api === 0) {
    } else {
      if (para?.asOfDate) {
        getMarketSegmentData();
      }
    }
  }, [para?.asOfDate, callApi.current, selectedMonth]);

  useLayoutEffect(() => {
    if (clickedTrRef.current) {
      showOnApiCall(clickedTrRef.current);
    }
  }, [
    rateCodeDataRef.current,
    companyDataRef.current,
    guestDataRef.current,
    segmentDrilldownData,
  ]);

  const chartDoughnutOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    elements: {
      arc: {
        borderWidth: 0,
        spacing: 0,
      },
    },
    legend: {
      display: true,
      position: "right",
    },
  };

  const [tblids, settblids] = useState({
    annualSummaryMonthly: commonService.GenerateGUID(),
    eMonthlyData: commonService.GenerateGUID(),
    eReservationData: commonService.GenerateGUID(),
    drilldown: commonService.GenerateGUID(),
  });
  return (
    <div>
      <Form.Select
        className="width150 mb-2"
        value={selectedMonth}
        onChange={(e) => {
          if (e?.target?.value) {
            let date = moment(
              `${e.target.value} ${new Date().getFullYear()}`,
              "MMMM YYYY"
            );
            let startDate = date.format("YYYY-MM-DD");
            let lastDate = date.endOf("month").format("YYYY-MM-DD");
            bookingPaceChartDateRef.current = lastDate;
            if (moment(defaultAsOfDateFromRTK).isSameOrBefore(lastDate)) {
              bookingPaceChartDateRef.current = defaultAsOfDateFromRTK;
            }
            monthStartDateRef.current = startDate;
            monthEndDateRef.current = lastDate;
          } else {
            monthStartDateRef.current = "";
            monthEndDateRef.current = "";
            bookingPaceChartDateRef.current = "";
          }
          setSelectedMonth(e.target.value);
        }}
      >
        <option value="">Select Month</option>
        {month?.map((item, index) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </Form.Select>
      {/* ANNUAL SUMMARY DATA */}
      <div className="eMonthlyData-widget-container">
        <p>{`Annual Summary`}</p>
        {api !== 0 && (
          <div className="gap-1 eMonthlyData-widget-container-menu">
            {/* <Button
              className="heading-menu-btns"
              type="button"
              onClick={() => {
                clickedDateForNote.current = "";
                setShowNoteSidebar(true);
              }}
            >
              <img src={NoteIcon} alt="note" />
            </Button> */}
            <Button
              className="heading-menu-btns"
              type="button"
              title="Send Mail"
            >
              <img
                src={emailIcon}
                alt="emailIcon"
                onClick={() => {
                  commonService.fnSendWidgetMail(
                    tblids.annualSummaryMonthly,
                    "Email Monthly Data",
                    snapshotId,
                    defaultAsOfDateFromRTK,
                    "",
                    para?.widgetId
                  );
                }}
              />
            </Button>
            <Button className="heading-menu-btns" type="button">
              <img
                src={infoIcon}
                alt="info"
                onClick={() => {
                  widgetDetailRef.current = {
                    widgetdetails: "",
                    usernote: "",
                    compName: compName?.monthlyDataForEmail,
                    widgetId: para?.widgetId,
                  };
                  setWidgetModal(true);
                }}
              />
            </Button>
            <Button className="heading-menu-btns" type="button">
              <img
                src={downloadIcon}
                alt="download"
                import={tblids.annualSummaryMonthly}
                onClick={() =>
                  commonService.fnExportInCSV(
                    tblids.annualSummaryMonthly,
                    // "Email Monthly Data"
                    `${para?.propertyCode}-Email Monthly Data-${moment(
                      new Date()
                    ).format("MMDDYYYY")}`
                  )
                }
              />
            </Button>
          </div>
        )}
        <div className="ViewPropertySetupTable">
          <div className="stripped__table">
            <Table id={tblids.annualSummaryMonthly} responsive>
              <thead>
                <tr>
                  <th className="border_right"></th>
                  <th colSpan={4} className="text-center border_right">
                    On The Book
                  </th>
                  <th colSpan={4} className="text-center border_right">
                    Net Stly
                  </th>
                  <th colSpan={4} className="text-center border_right">
                    Total Ly
                  </th>
                  <th colSpan={4} className="text-center border_right">
                    Budget
                  </th>
                  <th colSpan={4} className="text-center">
                    Forecast
                  </th>
                </tr>
                <tr>
                  <th className="border_right"></th>
                  <th className="text-center">OCC</th>
                  <th className="text-center">RMS</th>
                  <th className="text-end">ADR</th>
                  <th className="border_right text-end">REV</th>
                  <th className="text-center">OCC</th>
                  <th className="text-center">RMS</th>
                  <th className="text-end">ADR</th>
                  <th className="border_right text-end">REV</th>
                  <th className="text-center">OCC</th>
                  <th className="text-center">RMS</th>
                  <th className="text-end">ADR</th>
                  <th className="border_right text-end">REV</th>
                  <th className="text-center">OCC</th>
                  <th className="text-center">RMS</th>
                  <th className="text-end">ADR</th>
                  <th className="border_right text-end">REV</th>
                  <th className="text-center">OCC</th>
                  <th className="text-center">RMS</th>
                  <th className="text-end">ADR</th>
                  <th className="text-end">REV</th>
                </tr>
              </thead>
              <tbody>
                {monthDataLoading ? (
                  <tr style={{ height: "80px", position: "relative" }}>
                    <Loader />
                  </tr>
                ) : (
                  monthDataArrRef.current?.map((item, index) => {
                    let singleData = monthData?.filter(
                      (x) => item === x?.Month?.trim()
                    );

                    return (
                      <tr key={item} className="shadowOnHover">
                        {/* <td className="border_right">{`${item} ${moment(
                          para?.asOfDate
                        ).format("YYYY")}`}</td> */}
                        <td className="border_right">{`${item} ${singleData?.[0]?.Year}`}</td>
                        <td className="text-center">
                          {singleData?.[0]?.OCC ? singleData?.[0]?.OCC : 0}%
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.RMS
                            ? commonService.formateRoom(singleData?.[0]?.RMS)
                            : 0}
                        </td>
                        <td className="text-end">
                          {singleData?.[0]?.ADR
                            ? commonService.formateAmount(singleData?.[0]?.ADR)
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="border_right text-end">
                          {singleData?.[0]?.REV
                            ? commonService.formateAmount(singleData?.[0]?.REV)
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.STLY_OCC
                            ? singleData?.[0]?.STLY_OCC
                            : 0}
                          %
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.STLY_RMS
                            ? commonService.formateRoom(
                                singleData?.[0]?.STLY_RMS
                              )
                            : 0}
                        </td>
                        <td className="text-end">
                          {singleData?.[0]?.STLY_ADR
                            ? commonService.formateAmount(
                                singleData?.[0]?.STLY_ADR
                              )
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="border_right text-end">
                          {singleData?.[0]?.STLY_REV
                            ? commonService.formateAmount(
                                singleData?.[0]?.STLY_REV
                              )
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.LY_OCC
                            ? singleData?.[0]?.LY_OCC
                            : 0}
                          %
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.LY_RMS
                            ? commonService.formateRoom(singleData?.[0]?.LY_RMS)
                            : 0}
                        </td>
                        <td className="text-end">
                          {singleData?.[0]?.LY_ADR
                            ? commonService.formateAmount(
                                singleData?.[0]?.LY_ADR
                              )
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="border_right text-end">
                          {singleData?.[0]?.LY_REV
                            ? commonService.formateAmount(
                                singleData?.[0]?.LY_REV
                              )
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.BUDGET_OCC
                            ? singleData?.[0]?.BUDGET_OCC
                            : 0}
                          %
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.BUDGET_RMS
                            ? commonService.formateRoom(
                                singleData?.[0]?.BUDGET_RMS
                              )
                            : 0}
                        </td>
                        <td className="text-end">
                          {singleData?.[0]?.BUDGET_ADR
                            ? commonService.formateAmount(
                                singleData?.[0]?.BUDGET_ADR
                              )
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="border_right text-end">
                          {singleData?.[0]?.BUDGET_REV
                            ? commonService.formateAmount(
                                singleData?.[0]?.BUDGET_REV
                              )
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.FORECAST_OCC
                            ? singleData?.[0]?.FORECAST_OCC
                            : 0}
                          %
                        </td>
                        <td className="text-center">
                          {singleData?.[0]?.FORECAST_RMS
                            ? commonService.formateRoom(
                                singleData?.[0]?.FORECAST_RMS
                              )
                            : 0}
                        </td>
                        <td className="text-end">
                          {singleData?.[0]?.FORECAST_ADR
                            ? commonService.formateAmount(
                                singleData?.[0]?.FORECAST_ADR
                              )
                            : commonService.formateAmount(0)}
                        </td>
                        <td className="text-end">
                          {singleData?.[0]?.FORECAST_REV
                            ? commonService.formateAmount(
                                singleData?.[0]?.FORECAST_REV
                              )
                            : commonService.formateAmount(0)}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      {/* BOOKING PACE CHART */}
      <div className="mt-3 ebookingPace-widget-container">
        <p>{`Booking Pace (${moment(
          bookingPaceChartDateRef.current
            ? bookingPaceChartDateRef.current
            : para?.asOfDate
        ).format("MMMM YYYY")})`}</p>
        {api !== 0 && (
          <div className="gap-1 ebookingPace-widget-container-menu">
            {/* <Button className="heading-menu-btns" type="button">
              <img
                src={NoteIcon}
                alt="menuIcon"
                onClick={() => {
                  clickedDateForNote.current = "";
                  setShowNoteSidebar(true);
                }}
              />
            </Button> */}
            <Button className="heading-menu-btns" type="button">
              <img
                src={infoIcon}
                alt="info"
                onClick={() => {
                  widgetDetailRef.current = {
                    widgetdetails: "",
                    usernote: "",
                    compName: compName?.monthlyDataForEmail,
                    widgetId: para?.widgetId,
                  };
                  setWidgetModal(true);
                }}
              />
            </Button>
          </div>
        )}
        {chartData && (
          <div className="ForecastHorizontalChartInner">
            <Line data={chartDetail} options={chartOptions} />
          </div>
        )}
      </div>

      {/* SIXTY DAY OUTLOOK */}
      <div>
        <p>{`Next Month Outlook ${moment(
          monthStartDateRef.current ? monthStartDateRef.current : new Date()
        ).format("MMMM YYYY")}`}</p>
        <SixtyDayChild
          api={api}
          para={{
            ...para,
            monthStart: monthStartDateRef.current,
            monthEnd: monthEndDateRef.current,
          }}
        />
      </div>

      {/* DRILLDOWN DATA */}
      <div className="mt-3 weeklydrilldown-widget-container">
        <p>{`Segment Drildown (${moment(
          monthStartDateRef.current ? monthStartDateRef.current : para?.asOfDate
        ).format("MMMM YYYY")})`}</p>
        {api !== 0 && (
          <div className="gap-1 weeklydrilldown-widget-container-menu">
            <Button
              className="heading-menu-btns"
              type="button"
              title="Send Mail"
            >
              <img
                src={emailIcon}
                alt="emailIcon"
                onClick={() => {
                  commonService.fnSendWidgetMail(
                    tblids.drilldown,
                    "Email Monthly Data",
                    snapshotId,
                    defaultAsOfDateFromRTK,
                    "",
                    para?.widgetId
                  );
                }}
              />
            </Button>
            <Button className="heading-menu-btns" type="button">
              <img
                src={infoIcon}
                alt="info"
                onClick={() => {
                  widgetDetailRef.current = {
                    widgetdetails: "",
                    usernote: "",
                    compName: compName?.weeklyDataForEmail,
                    widgetId: para?.widgetId,
                  };
                  setWidgetModal(true);
                }}
              />
            </Button>
            <Button className="heading-menu-btns" type="button">
              <img
                src={downloadIcon}
                alt="download"
                import={tblids.drilldown}
                onClick={() =>
                  commonService.fnExportInCSV(
                    tblids.drilldown,
                    // "Email Monthly Data"
                    `${para?.propertyCode}-Email Monthly Data-${moment(
                      new Date()
                    ).format("MMDDYYYY")}`
                  )
                }
              />
            </Button>
          </div>
        )}
        <div className="ViewPropertySetupTable">
          <div className="table__container">
            <div className="stripped__table">
              <Table id={tblids.drilldown} responsive>
                <thead>
                  <tr>
                    <th className="border_right text-center"></th>
                    <th colSpan={4} className="border_right text-center"></th>
                    <th colSpan={4} className="border_right text-center"></th>
                    <th colSpan={4} className="text-center">
                      Variance
                    </th>
                  </tr>
                  <tr>
                    <th className="border_right"></th>
                    <th className="text-center">Room Nights</th>
                    <th className="text-end">ADR</th>
                    <th className="text-end">Revenue</th>
                    <th className="border_right text-center">
                      Rev Contribution
                    </th>
                    <th className="text-center">Room Nights</th>
                    <th className="text-end">ADR</th>
                    <th className="text-end">Revenue</th>
                    <th className="border_right text-center">
                      Rev Contribution
                    </th>
                    <th className="text-center">Room Nights</th>
                    <th className="text-end">ADR</th>
                    <th className="text-end">Revenue</th>
                    <th className="text-center">Rev Contribution</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr style={{ height: "80px", position: "relative" }}>
                      <Loader />
                    </tr>
                  ) : (
                    segmentDrilldownData &&
                    segmentDrilldownData?.map((item, index) => {
                      let msLeftRevContri = 0,
                        msRightRevContri = 0;
                      if (item?.left_REV > 0 && totalRef.current?.leftRev > 0) {
                        msLeftRevContri = (
                          (parseInt(item?.left_REV) * 100) /
                          totalRef.current?.leftRev
                        )?.toFixed(1);
                      }

                      if (
                        item?.right_REV > 0 &&
                        totalRef.current?.rightRev > 0
                      ) {
                        msRightRevContri = (
                          (parseInt(item?.right_REV) * 100) /
                          totalRef.current?.rightRev
                        )?.toFixed(1);
                      }
                      return (
                        <>
                          <tr id={item?.guid} className="shadowOnHover">
                            <td className="border_right">
                              <div
                                className={`d-flex gap-2`}
                                onClick={() => {
                                  let findSelectedMarketSegment =
                                    calledMarketSegmentRef.current?.filter(
                                      (x) => x === item?.name
                                    );

                                  if (findSelectedMarketSegment?.length > 0) {
                                    const classList =
                                      document.getElementsByClassName(
                                        item?.guid
                                      );
                                    if (
                                      classList?.[0]?.classList?.contains(
                                        "nestedTableRowNone"
                                      )
                                    ) {
                                      handleShowHideRow(item?.guid);
                                    } else {
                                      handleShowHideRow(item?.guid, item);
                                    }
                                  } else {
                                    if (!msLoading) {
                                      selectedMarketSegmentRef.current =
                                        item?.name;
                                      clickedTrRef.current = [item?.guid];
                                      getRateCodeData();
                                    }
                                  }
                                }}
                              >
                                <p>{item?.name}</p>
                                <img src={downArrow} />

                                {msLoading &&
                                  selectedMarketSegmentRef.current ===
                                    item?.name && (
                                    <div
                                      class="spinner-border text-primary ms-2"
                                      role="status"
                                      style={{
                                        height: "13px",
                                        width: "13px",
                                        color: "#3565FC",
                                      }}
                                    >
                                      <span class="sr-only"></span>
                                    </div>
                                  )}
                              </div>
                            </td>
                            <td className="text-center">
                              {item?.left_RMS
                                ? commonService.formateRoom(item?.left_RMS)
                                : 0}
                            </td>
                            <td className="text-end">
                              {item?.left_ADR
                                ? `${commonService.formateAmount(
                                    item?.left_ADR
                                  )}`
                                : `${commonService.formateAmount(0)}`}
                            </td>
                            <td className="text-end">
                              {item?.left_REV
                                ? `${commonService.formateAmount(
                                    item?.left_REV
                                  )}`
                                : `${commonService.formateAmount(0)}`}
                            </td>
                            <td className="border_right text-center">
                              {msLeftRevContri}%
                            </td>
                            <td className="text-center">
                              {item?.right_RMS
                                ? commonService.formateRoom(item?.right_RMS)
                                : 0}
                            </td>
                            <td className="text-end">
                              {item?.right_ADR
                                ? `${commonService.formateAmount(
                                    item?.right_ADR
                                  )}`
                                : `${commonService.formateAmount(0)}`}
                            </td>
                            <td className="text-end">
                              {item?.right_REV
                                ? `${commonService.formateAmount(
                                    item?.right_REV
                                  )}`
                                : `${commonService.formateAmount(0)}`}
                            </td>
                            <td className="border_right text-center">
                              {msRightRevContri}%
                            </td>
                            <td
                              className={`text-center ${
                                item?.varientRms < 0 ? "redText" : ""
                              }`}
                            >
                              {commonService.formateRoom(item?.varientRms)}
                            </td>
                            <td
                              className={`text-end ${
                                item?.varientAdr < 0 ? "redText" : ""
                              }`}
                            >
                              {commonService.formateAmount(item?.varientAdr)}
                            </td>
                            <td
                              className={`text-end ${
                                item?.varientRev < 0 ? "redText" : ""
                              }`}
                            >
                              {commonService.formateAmount(item?.varientRev)}
                            </td>
                            <td
                              className={`text-center ${
                                (msLeftRevContri - msRightRevContri)?.toFixed(
                                  1
                                ) < 0
                                  ? "redText"
                                  : ""
                              }`}
                            >
                              {(msLeftRevContri - msRightRevContri)?.toFixed(1)}
                              %
                            </td>
                          </tr>
                          {Array.isArray(item?.items) &&
                            item?.items?.length > 0 &&
                            item?.items?.map((rateCodeItem, rateCodeIndex) => {
                              let rateCodeLeftRevContri = 0,
                                rateCodeRightRevContri = 0;
                              if (
                                rateCodeItem?.left_REV > 0 &&
                                totalRef.current?.leftRev > 0
                              ) {
                                rateCodeLeftRevContri = (
                                  (parseInt(rateCodeItem?.left_REV) * 100) /
                                  totalRef.current?.leftRev
                                )?.toFixed(1);
                              }

                              if (
                                rateCodeItem?.right_REV > 0 &&
                                totalRef.current?.rightRev > 0
                              ) {
                                rateCodeRightRevContri = (
                                  (parseInt(rateCodeItem?.right_REV) * 100) /
                                  totalRef.current?.rightRev
                                )?.toFixed(1);
                              }
                              return (
                                <>
                                  <tr
                                    className={`${item?.guid} nestedTableRowNone shadowOnHover`}
                                    id={rateCodeItem?.guid}
                                  >
                                    <td className="border_right">
                                      <div
                                        style={{ paddingLeft: "10px" }}
                                        className="d-flex gap-2"
                                        onClick={() => {
                                          if (!rateCodeLoading) {
                                            selectedMarketSegmentRef.current =
                                              item?.name;
                                            selectedRateCodeRef.current =
                                              rateCodeItem?.name;
                                          }
                                          let findSelectedRateCode =
                                            calledRateCodeRef.current?.filter(
                                              (x) =>
                                                x?.ms ===
                                                  selectedMarketSegmentRef.current &&
                                                x?.rc ===
                                                  selectedRateCodeRef.current
                                            );

                                          if (
                                            findSelectedRateCode?.length > 0
                                          ) {
                                            const classList =
                                              document.getElementsByClassName(
                                                rateCodeItem?.guid
                                              );

                                            if (
                                              classList?.[0]?.classList?.contains(
                                                "nestedTableRowNone"
                                              )
                                            ) {
                                              handleShowHideRow(
                                                rateCodeItem?.guid
                                              );
                                            } else {
                                              handleShowHideRow(
                                                rateCodeItem?.guid,
                                                rateCodeItem
                                              );
                                            }
                                          } else {
                                            if (!rateCodeLoading) {
                                              clickedTrRef.current = [
                                                ...clickedTrRef.current,
                                                rateCodeItem?.guid,
                                              ];
                                              getCompanyData();
                                            }
                                          }
                                        }}
                                      >
                                        <p>{rateCodeItem?.name}</p>
                                        <img src={downArrow} />
                                        {rateCodeLoading &&
                                          selectedMarketSegmentRef.current ===
                                            item?.name &&
                                          selectedRateCodeRef.current ===
                                            rateCodeItem?.name && (
                                            <div
                                              class="spinner-border text-primary ms-2"
                                              role="status"
                                              style={{
                                                height: "13px",
                                                width: "13px",
                                                color: "#3565FC",
                                              }}
                                            >
                                              <span class="sr-only"></span>
                                            </div>
                                          )}
                                      </div>
                                    </td>

                                    <td className="text-center">
                                      {rateCodeItem?.left_RMS
                                        ? commonService.formateRoom(
                                            rateCodeItem?.left_RMS
                                          )
                                        : 0}
                                    </td>
                                    <td className="text-end">
                                      {rateCodeItem?.left_ADR
                                        ? `${commonService.formateAmount(
                                            rateCodeItem?.left_ADR
                                          )}`
                                        : `${commonService.formateAmount(0)}`}
                                    </td>
                                    <td className="text-end">
                                      {rateCodeItem?.left_REV
                                        ? `${commonService.formateAmount(
                                            rateCodeItem?.left_REV
                                          )}`
                                        : `${commonService.formateAmount(0)}`}
                                    </td>
                                    <td className="border_right text-center">
                                      {rateCodeLeftRevContri}%
                                    </td>
                                    <td className="text-center">
                                      {rateCodeItem?.right_RMS
                                        ? commonService.formateRoom(
                                            rateCodeItem?.right_RMS
                                          )
                                        : 0}
                                    </td>
                                    <td className="text-end">
                                      {rateCodeItem?.right_ADR
                                        ? `${commonService.formateAmount(
                                            rateCodeItem?.right_ADR
                                          )}`
                                        : `${commonService.formateAmount(0)}`}
                                    </td>
                                    <td className="text-end">
                                      {rateCodeItem?.right_REV
                                        ? `${commonService.formateAmount(
                                            rateCodeItem?.right_REV
                                          )}`
                                        : `${commonService.formateAmount(0)}`}
                                    </td>
                                    <td className="border_right text-center">
                                      {rateCodeRightRevContri}%
                                    </td>
                                    <td
                                      className={`text-center ${
                                        rateCodeItem?.varientRms < 0
                                          ? "redText"
                                          : ""
                                      }`}
                                    >
                                      {commonService.formateRoom(
                                        rateCodeItem?.varientRms
                                      )}
                                    </td>
                                    <td
                                      className={`text-end ${
                                        rateCodeItem?.varientAdr < 0
                                          ? "redText"
                                          : ""
                                      }`}
                                    >
                                      {commonService.formateAmount(
                                        rateCodeItem?.varientAdr
                                      )}
                                    </td>
                                    <td
                                      className={`text-end ${
                                        rateCodeItem?.varientRev < 0
                                          ? "redText"
                                          : ""
                                      }`}
                                    >
                                      {commonService.formateAmount(
                                        rateCodeItem?.varientRev
                                      )}
                                    </td>
                                    <td
                                      className={`text-center ${
                                        (
                                          rateCodeLeftRevContri -
                                          rateCodeRightRevContri
                                        )?.toFixed(1) < 0
                                          ? "redText"
                                          : ""
                                      }`}
                                    >
                                      {(
                                        rateCodeLeftRevContri -
                                        rateCodeRightRevContri
                                      )?.toFixed(1)}
                                      %
                                    </td>
                                  </tr>
                                  {Array.isArray(rateCodeItem?.items) &&
                                    rateCodeItem?.items?.length > 0 &&
                                    rateCodeItem?.items?.map(
                                      (companyItem, companyIndex) => {
                                        let companyItemLeftRevContri = 0,
                                          companyItemRightRevContri = 0;
                                        if (
                                          companyItem?.left_REV > 0 &&
                                          totalRef.current?.leftRev > 0
                                        ) {
                                          companyItemLeftRevContri = (
                                            (parseInt(companyItem?.left_REV) *
                                              100) /
                                            totalRef.current?.leftRev
                                          )?.toFixed(1);
                                        }

                                        if (
                                          companyItem?.right_REV > 0 &&
                                          totalRef.current?.rightRev > 0
                                        ) {
                                          companyItemRightRevContri = (
                                            (parseInt(companyItem?.right_REV) *
                                              100) /
                                            totalRef.current?.rightRev
                                          )?.toFixed(1);
                                        }
                                        return (
                                          <>
                                            <tr
                                              className={`${rateCodeItem?.guid} nestedTableRowNone shadowOnHover`}
                                              id={companyItem?.guid}
                                            >
                                              <td className="border_right">
                                                <div
                                                  style={{
                                                    paddingLeft: "20px",
                                                  }}
                                                  className="d-flex gap-2"
                                                  onClick={() => {
                                                    if (!companyLoading) {
                                                      selectedMarketSegmentRef.current =
                                                        item?.name;
                                                      selectedRateCodeRef.current =
                                                        rateCodeItem?.name;
                                                      selectedCompanyRef.current =
                                                        companyItem?.name;
                                                    }
                                                    let findSelectedCompany =
                                                      calledCompanyRef.current?.filter(
                                                        (x) =>
                                                          x?.ms ===
                                                            selectedMarketSegmentRef.current &&
                                                          x?.rc ===
                                                            selectedRateCodeRef.current &&
                                                          x?.company ===
                                                            selectedCompanyRef.current
                                                      );

                                                    if (
                                                      findSelectedCompany?.length >
                                                      0
                                                    ) {
                                                      const classList =
                                                        document.getElementsByClassName(
                                                          companyItem?.guid
                                                        );

                                                      if (
                                                        classList?.[0]?.classList?.contains(
                                                          "nestedTableRowNone"
                                                        )
                                                      ) {
                                                        handleShowHideRow(
                                                          companyItem?.guid
                                                        );
                                                      } else {
                                                        handleShowHideRow(
                                                          companyItem?.guid,
                                                          companyItem
                                                        );
                                                      }
                                                    } else {
                                                      if (!companyLoading) {
                                                        clickedTrRef.current = [
                                                          ...clickedTrRef.current,
                                                          companyItem?.guid,
                                                        ];
                                                        getGuestData();
                                                      }
                                                    }
                                                  }}
                                                >
                                                  <p>{companyItem?.name}</p>
                                                  <img src={downArrow} />
                                                  {companyLoading &&
                                                    selectedMarketSegmentRef.current ===
                                                      item?.name &&
                                                    selectedRateCodeRef.current ===
                                                      rateCodeItem?.name &&
                                                    selectedCompanyRef.current ===
                                                      companyItem?.name && (
                                                      <div
                                                        class="spinner-border text-primary ms-2"
                                                        role="status"
                                                        style={{
                                                          height: "13px",
                                                          width: "13px",
                                                          color: "#3565FC",
                                                        }}
                                                      >
                                                        <span class="sr-only"></span>
                                                      </div>
                                                    )}
                                                </div>
                                              </td>

                                              <td className="text-center">
                                                {companyItem?.left_RMS
                                                  ? commonService.formateRoom(
                                                      companyItem?.left_RMS
                                                    )
                                                  : 0}
                                              </td>
                                              <td className="text-end">
                                                {companyItem?.left_ADR
                                                  ? `${commonService.formateAmount(
                                                      companyItem?.left_ADR
                                                    )}`
                                                  : `${commonService.formateAmount(
                                                      0
                                                    )}`}
                                              </td>
                                              <td className="text-end">
                                                {companyItem?.left_REV
                                                  ? `${commonService.formateAmount(
                                                      companyItem?.left_REV
                                                    )}`
                                                  : `${commonService.formateAmount(
                                                      0
                                                    )}`}
                                              </td>
                                              <td className="border_right text-center">
                                                {companyItemLeftRevContri}%
                                              </td>
                                              <td className="text-center">
                                                {companyItem?.right_RMS
                                                  ? commonService.formateRoom(
                                                      companyItem?.right_RMS
                                                    )
                                                  : 0}
                                              </td>
                                              <td className="text-end">
                                                {companyItem?.right_ADR
                                                  ? `${commonService.formateAmount(
                                                      companyItem?.right_ADR
                                                    )}`
                                                  : `${commonService.formateAmount(
                                                      0
                                                    )}`}
                                              </td>
                                              <td className="text-end">
                                                {companyItem?.right_REV
                                                  ? `${commonService.formateAmount(
                                                      companyItem?.right_REV
                                                    )}`
                                                  : `${commonService.formateAmount(
                                                      0
                                                    )}`}
                                              </td>
                                              <td className="border_right text-center">
                                                {companyItemRightRevContri}%
                                              </td>
                                              <td
                                                className={`text-center ${
                                                  companyItem?.varientRms < 0
                                                    ? "redText"
                                                    : ""
                                                }`}
                                              >
                                                {commonService.formateRoom(
                                                  companyItem?.varientRms
                                                )}
                                              </td>
                                              <td
                                                className={`text-end ${
                                                  companyItem?.varientAdr < 0
                                                    ? "redText"
                                                    : ""
                                                }`}
                                              >
                                                {commonService.formateAmount(
                                                  companyItem?.varientAdr
                                                )}
                                              </td>
                                              <td
                                                className={`text-end ${
                                                  companyItem?.varientRev < 0
                                                    ? "redText"
                                                    : ""
                                                }`}
                                              >
                                                {commonService.formateAmount(
                                                  companyItem?.varientRev
                                                )}
                                              </td>
                                              <td
                                                className={`text-center ${
                                                  (
                                                    companyItemLeftRevContri -
                                                    companyItemRightRevContri
                                                  )?.toFixed(1) < 0
                                                    ? "redText"
                                                    : ""
                                                }`}
                                              >
                                                {(
                                                  companyItemLeftRevContri -
                                                  companyItemRightRevContri
                                                )?.toFixed(1)}
                                                %
                                              </td>
                                            </tr>
                                            {Array.isArray(
                                              companyItem?.items
                                            ) &&
                                              companyItem?.items?.length > 0 &&
                                              companyItem?.items?.map(
                                                (guestItem, guestIndex) => {
                                                  let guestLeftRevContri = 0,
                                                    guestRightRevContri = 0;
                                                  if (
                                                    guestItem?.left_REV > 0 &&
                                                    totalRef.current?.leftRev >
                                                      0
                                                  ) {
                                                    guestLeftRevContri = (
                                                      (parseInt(
                                                        guestItem?.left_REV
                                                      ) *
                                                        100) /
                                                      totalRef.current?.leftRev
                                                    )?.toFixed(1);
                                                  }

                                                  if (
                                                    guestItem?.right_REV > 0 &&
                                                    totalRef.current?.rightRev >
                                                      0
                                                  ) {
                                                    guestRightRevContri = (
                                                      (parseInt(
                                                        guestItem?.right_REV
                                                      ) *
                                                        100) /
                                                      totalRef.current?.rightRev
                                                    )?.toFixed(1);
                                                  }
                                                  return (
                                                    <tr
                                                      className={`${companyItem?.guid} nestedTableRowNone shadowOnHover`}
                                                      onClick={(e) => {
                                                        checkActiveRow(e);
                                                      }}
                                                    >
                                                      <td className="border_right">
                                                        <div
                                                          style={{
                                                            paddingLeft: "30px",
                                                          }}
                                                          className="d-flex gap-2"
                                                        >
                                                          <p>
                                                            {guestItem?.name}
                                                          </p>
                                                        </div>
                                                      </td>
                                                      <td className="text-center">
                                                        {guestItem?.left_RMS
                                                          ? commonService.formateRoom(
                                                              guestItem?.left_RMS
                                                            )
                                                          : 0}
                                                      </td>
                                                      <td className="text-end">
                                                        {guestItem?.left_ADR
                                                          ? `${commonService.formateAmount(
                                                              guestItem?.left_ADR
                                                            )}`
                                                          : `${commonService.formateAmount(
                                                              0
                                                            )}`}
                                                      </td>
                                                      <td className="text-end">
                                                        {guestItem?.left_REV
                                                          ? `${commonService.formateAmount(
                                                              guestItem?.left_REV
                                                            )}`
                                                          : `${commonService.formateAmount(
                                                              0
                                                            )}`}
                                                      </td>
                                                      <td className="border_right text-center">
                                                        {guestLeftRevContri}%
                                                      </td>
                                                      <td className="text-center">
                                                        {guestItem?.right_RMS
                                                          ? commonService.formateRoom(
                                                              guestItem?.right_RMS
                                                            )
                                                          : 0}
                                                      </td>
                                                      <td className="text-end">
                                                        {guestItem?.right_ADR
                                                          ? `${commonService.formateAmount(
                                                              guestItem?.right_ADR
                                                            )}`
                                                          : `${commonService.formateAmount(
                                                              0
                                                            )}`}
                                                      </td>
                                                      <td className="text-end">
                                                        {guestItem?.right_REV
                                                          ? `${commonService.formateAmount(
                                                              guestItem?.right_REV
                                                            )}`
                                                          : `${commonService.formateAmount(
                                                              0
                                                            )}`}
                                                      </td>
                                                      <td className="border_right text-center">
                                                        {guestRightRevContri}%
                                                      </td>
                                                      <td
                                                        className={`text-center ${
                                                          guestItem?.varientRms <
                                                          0
                                                            ? "redText"
                                                            : ""
                                                        }`}
                                                      >
                                                        {commonService.formateRoom(
                                                          guestItem?.varientRms
                                                        )}
                                                      </td>
                                                      <td
                                                        className={`text-end ${
                                                          guestItem?.varientAdr <
                                                          0
                                                            ? "redText"
                                                            : ""
                                                        }`}
                                                      >
                                                        {commonService.formateAmount(
                                                          guestItem?.varientAdr
                                                        )}
                                                      </td>
                                                      <td
                                                        className={`text-end ${
                                                          guestItem?.varientRev <
                                                          0
                                                            ? "redText"
                                                            : ""
                                                        }`}
                                                      >
                                                        {commonService.formateAmount(
                                                          guestItem?.varientRev
                                                        )}
                                                      </td>
                                                      <td
                                                        className={`text-center ${
                                                          (
                                                            guestLeftRevContri -
                                                            guestRightRevContri
                                                          )?.toFixed(1) < 0
                                                            ? "redText"
                                                            : ""
                                                        }`}
                                                      >
                                                        {(
                                                          guestLeftRevContri -
                                                          guestRightRevContri
                                                        )?.toFixed(1)}
                                                        %
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                          </>
                                        );
                                      }
                                    )}
                                </>
                              );
                            })}
                          {index === segmentDrilldownData?.length - 1 && (
                            <tr className="shadowOnHover">
                              <td className="border_right boldTd">Totals</td>
                              <td className="text-center boldTd">
                                {commonService.formateRoom(
                                  totalRef.current.leftRoom
                                )}
                              </td>
                              <td className="text-end boldTd">
                                {totalRef.current.leftRoom > 0 &&
                                totalRef.current.leftRev > 0
                                  ? commonService.formateAmount(
                                      Math.round(
                                        totalRef.current.leftRev /
                                          totalRef.current.leftRoom
                                      )
                                    )
                                  : commonService.formateAmount(0)}
                              </td>
                              <td className="text-end boldTd">
                                {commonService.formateAmount(
                                  totalRef.current.leftRev
                                )}
                              </td>
                              <td className="border_right text-center boldTd">
                                {totalRef.current.leftRevContri}%
                              </td>
                              <td className="text-center boldTd">
                                {commonService.formateRoom(
                                  totalRef.current.rightRoom
                                )}
                              </td>
                              <td className="text-end boldTd">
                                {totalRef.current.rightRoom > 0 &&
                                totalRef.current.rightRev > 0
                                  ? commonService.formateAmount(
                                      Math.round(
                                        totalRef.current.rightRev /
                                          totalRef.current.rightRoom
                                      )
                                    )
                                  : commonService.formateAmount(0)}
                              </td>
                              <td className="text-end boldTd">
                                {commonService.formateAmount(
                                  totalRef.current.rightRev
                                )}
                              </td>
                              <td className="border_right text-center boldTd">
                                {totalRef.current.rightRevContri}%
                              </td>
                              <td className="text-center boldTd">
                                {commonService.formateRoom(
                                  totalRef.current.leftRoom -
                                    totalRef.current.rightRoom
                                )}
                              </td>
                              <td className="text-end boldTd">
                                {propertyDetailFromRTK?.currency_term
                                  ? propertyDetailFromRTK?.currency_term
                                  : "$"}
                                {(totalRef.current.leftRoom > 0 &&
                                totalRef.current.leftRev > 0
                                  ? Math.round(
                                      totalRef.current.leftRev /
                                        totalRef.current.leftRoom
                                    )
                                  : 0) -
                                  (totalRef.current.rightRoom > 0 &&
                                  totalRef.current.rightRev > 0
                                    ? Math.round(
                                        totalRef.current.rightRev /
                                          totalRef.current.rightRoom
                                      )
                                    : 0)}
                              </td>
                              <td className="text-end boldTd">
                                {commonService.formateAmount(
                                  totalRef.current.leftRev -
                                    totalRef.current.rightRev
                                )}
                              </td>
                              <td className="boldTd"></td>
                            </tr>
                          )}
                        </>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
      {api !== 0 && <Comments widgetDetails={para} editorId={"MonthlyData"} />}

      {/* MARKET SEGMENT CHART */}
      <div className="mt-3">
        <p>Market Mix</p>
        <div>
          {loading ? (
            <Loader />
          ) : msChartData ? (
            <DoughnutChart data={msChartData} options={chartDoughnutOptions} />
          ) : (
            <div className="d-flex justify-content-center">No Data Found</div>
          )}
        </div>
      </div>

      {/* EVENT STRATEGY */}
      <div className="mt-3">
        <p>Event Strategy</p>
        <EventStretegy
          api={api}
          para={{
            ...para,
            monthStart: monthStartDateRef.current,
            monthEnd: monthEndDateRef.current,
          }}
        />
      </div>

      {showNoteSidebar && (
        <AddWidgetModal
          showModal={showNoteSidebar}
          closeModal={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default MonthlyData;
